import buttonForLeadIn from './buttonForLeadIn.vue'
export default buttonForLeadIn
